import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGhosteryComponent } from './simple-icons-ghostery.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGhosteryComponent ],
    exports:      [ SimpleIconsGhosteryComponent ],
    bootstrap:    []
})
export class SimpleIconsGhosteryModule {}
